module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (148).2d143af5.jpg";